import { Plus, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { LANG_LABELS_JA } from './GuidesTab';

// 申込編集：受講者の氏名・生年月日・性別・国籍・言語を編集（写真等の他項目は保持）
export const ParticipantsEditor = ({ participants, onChange, defaultLanguage = 'ja' }) => {
  const update = (idx, patch) => onChange(participants.map((p, i) => (i === idx ? { ...p, ...patch } : p)));
  const remove = (idx) => {
    if (!window.confirm(`受講者「${participants[idx]?.name || idx + 1}」を削除しますか？（保存で確定）`)) return;
    onChange(participants.filter((_, i) => i !== idx));
  };
  const add = () => onChange([...participants, { name: '', birthDate: '', gender: '', nationality: '', language: defaultLanguage }]);
  const sel = 'w-full border rounded-md px-2 py-1.5 text-sm bg-white';
  return (
    <div data-testid="app-edit-participants">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">受講者情報（{participants.length}名）</Label>
        <Button type="button" size="sm" variant="outline" onClick={add} disabled={participants.length >= 15} className="border-[#00A651] text-[#00A651]" data-testid="app-edit-add-participant">
          <Plus className="h-3.5 w-3.5 mr-1" />受講者を追加
        </Button>
      </div>
      <div className="space-y-2 mt-2">
        {participants.map((p, idx) => (
          <div key={idx} className="border rounded-lg p-2 bg-gray-50 grid grid-cols-2 sm:grid-cols-3 gap-1.5 items-end" data-testid={`app-edit-participant-${idx}`}>
            <div className="col-span-2 sm:col-span-3">
              <Label className="text-xs">受講者{idx + 1} 氏名</Label>
              <Input value={p.name || ''} onChange={(e) => update(idx, { name: e.target.value })} className="h-8" data-testid={`app-edit-participant-name-${idx}`} />
            </div>
            <div>
              <Label className="text-xs">生年月日</Label>
              <Input type="date" value={p.birthDate || ''} onChange={(e) => update(idx, { birthDate: e.target.value })} className="h-8" />
            </div>
            <div>
              <Label className="text-xs">性別</Label>
              <select value={p.gender || ''} onChange={(e) => update(idx, { gender: e.target.value })} className={sel}>
                <option value="">-</option>
                <option value="male">男性</option>
                <option value="female">女性</option>
              </select>
            </div>
            <div>
              <Label className="text-xs">言語</Label>
              <select value={p.language || ''} onChange={(e) => update(idx, { language: e.target.value })} className={sel} data-testid={`app-edit-participant-lang-${idx}`}>
                <option value="">-</option>
                {Object.entries(LANG_LABELS_JA).map(([code, label]) => <option key={code} value={code}>{label}</option>)}
              </select>
            </div>
            <div className="flex gap-1 items-end">
              <div className="flex-1 min-w-0">
                <Label className="text-xs">国籍</Label>
                <Input value={p.nationality || ''} onChange={(e) => update(idx, { nationality: e.target.value })} className="h-8" />
              </div>
              <Button type="button" size="sm" variant="ghost" onClick={() => remove(idx)} className="text-red-500 h-8 px-2" data-testid={`app-edit-remove-participant-${idx}`}>
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}
        {participants.length === 0 && <p className="text-xs text-gray-500">受講者が登録されていません。「受講者を追加」から登録できます。</p>}
      </div>
    </div>
  );
};

export default ParticipantsEditor;
